import { render, staticRenderFns } from "./healthManagement.vue?vue&type=template&id=a6265ce0&scoped=true&"
import script from "./healthManagement.vue?vue&type=script&lang=js&"
export * from "./healthManagement.vue?vue&type=script&lang=js&"
import style0 from "./healthManagement.vue?vue&type=style&index=0&id=a6265ce0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6265ce0",
  null
  
)

export default component.exports